import React from 'react';
import Title from '../../../../../@casino/ui/title';
import { useDispatch, useSelector } from 'react-redux';
import { useForm, useWatch } from 'react-hook-form';
import { makeStyles } from '@material-ui/core';
import FieldInput from '../../../../../@casino/ui/Fields/Input';
import FieldSelect from '../../../../../@casino/ui/Fields/Select';
import FieldsButton from '../../../../../@casino/ui/Fields/Button';
import FieldsDatePicker from '../../../../../@casino/ui/Fields/DatePicker';
import { setGetReplenishmentGeneralReport } from '../../store/thunk/setGetReplenishmentReport';
import TableCasino from '../../../../../@casino/ui/table';
import ModalAddMailing from '../../components/ModalAddMailing';
import {format} from 'date-fns';
const useStyles = makeStyles(() => ({
    root: {
        padding: 20,
        paddingTop: 0
    },
    wrap: {
        padding: 20,
        background: '#1b2039',
        borderRadius: 8,
        marginBottom: 12,
        display: 'flex',
        gap: '10px',
        flexDirection: 'column'
    },
    btn: {
        padding: '3px 14px',
        borderRadius: 4,
        background: '#ffc324',
        color: '#141b33',
        cursor: 'pointer',
        border: 'none',
        fontSize: 16
    },
}))

const GeneralReport = () => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const LIST_CURRENCY = [{
        label: 'RUB',
        value: 'RUB'
    }, {
        label: 'KZT',
        value: 'KZT'
    }, {
        label: 'UZS',
        value: 'UZS'
    }, {
        label: 'USD',
        value: 'USD'
    }, {
        label: 'EUR',
        value: 'EUR'
    }, {
        label: 'GEL',
        value: 'GEL'
    }, {
        label: 'TRY',
        value: 'TRY'
    }];

    const {
        register,
        handleSubmit,
        control,
        setValue
    } = useForm({
        mode: 'onChange',
        defaultValues: {
            login: '',
            currency: '',
            count_deposit_min: '',
            count_deposit_max: '',
            sum_deposit_min: '',
            sum_deposit_max: '',
            from_date: '',
            to_date: '',
            orderBy: 'total_amount,desc'
        }
    })

    const [login, currency, count_deposit_max, count_deposit_min, sum_deposit_max, sum_deposit_min, from_date, to_date, orderBy] = useWatch({
        control,
        name: ['login', 'currency', 'count_deposit_max', 'count_deposit_min', 'sum_deposit_max', 'sum_deposin_min', 'from_date', 'to_date', 'orderBy']
    });

    const [selectedLogin, setSelectedLogin] = React.useState(undefined);
    const [isOpenModalAddMailing, setIsOpenModalAddMailing] = React.useState(false);


    const onSubmit = (store) => {
        dispatch(setGetReplenishmentGeneralReport({
            ...store,
            page: 1,
            pageSize: 50
        }))
    }

    const columns = [
        { id: 'dublicate', label: "Статус"},
        { id: 'login', label: 'Логин'},
        { id: 'count_transactions', label: 'Кол-во депов', sort: true},
        { id: 'total_amount', label: 'Сумма депов', sort: true},
        { id: 'last_date', label: 'Последний деп.', sort: true},
        { id: 'tags', label: 'Теги', sort: true},
        { id: 'currency', label: 'Валюта'},
        { id: 'settings', label: 'Рассылка'}
    ];

    const handleIsOpenModalAddMailing = ({
        login
    }) => {
        setIsOpenModalAddMailing(value => !value)
        setSelectedLogin(login)
    }
    
    const getRows = (data) => {
        return data?.list?.map((item, key) => {
            return {
                id: key + 1,
                dublicate:  item.dublicate && (
                    <span
                        className={classes.btn}
                        style={{background: 'rgb(255, 64, 61)', color: '#FFFFFF'}}
                    >
                        Дубликат
                    </span>
                ),
                login: item.login || '-',
                count_transactions: new Intl.NumberFormat('ru-RU').format(item.count_transactions),
                total_amount: new Intl.NumberFormat('ru-RU').format(item.total_amount),
                currency: item.currency || '-',
                last_date: format(new Date(Number(item?.last_date || 0)), 'dd.MM.yyyy HH:mm'),
                tags: item.tags?.join(', '),
                settings: (
                    <button
                        type="button"
                        onClick={() => handleIsOpenModalAddMailing({login: item.login})}
                        className={classes.btn}
                    >
                        Добавить
                    </button>
                )
            }
        })
    }

    const data = useSelector((state) => state.replenishmentGeneralReport.data);

    const rows = React.useMemo(() => getRows(data), [data]);

    const handleChangeModeAddMailing = () => {
        setIsOpenModalAddMailing(false);
        setSelectedLogin(undefined)
    }

    return (
        <div className={classes.root}>
            <Title label="Общий отчёт" />
            <form onSubmit={handleSubmit(onSubmit)} className={classes.wrap}>
                <div style={{width: 600}}>  
                    <FieldsDatePicker
                        register={register}
                        label="Период депозита"
                    />
                </div>
                
                <div style={{ display: 'flex', columnGap: 20 }}>
                    <FieldInput
                        name="login"
                        placeholder="Поиск по логину"
                        register={register}
                    />
                    <FieldSelect
                        register={register}
                        label="Валюта"
                        name="currency"
                        list={LIST_CURRENCY}
                        defaultOption="Выбрать валюту"
                    />
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', rowGap: 10 }}>
                    <div style={{ display: 'flex', columnGap: 20, alignItems: 'center' }}>
                        <FieldInput
                            name="count_deposit_min"
                            placeholder="Кол-во депозитов от"
                            type="number"
                            register={register}
                        />
                        <FieldInput
                            name="count_deposit_max"
                            placeholder="Кол-во депозитов до"
                            type="number"
                            register={register}
                        />
                    </div>
                    <div style={{ display: 'flex', columnGap: 20, alignItems: 'center' }}>
                        <FieldInput
                            name="sum_deposit_min"
                            placeholder="Сумма депозитов от"
                            type="number"
                            register={register}
                        />
                        <FieldInput
                            name="sum_deposit_max"
                            placeholder="Сумма депозитов до"
                            type="number"
                            register={register}
                        />
                    </div>
                </div>
                <div style={{ display: 'flex', columnGap: 10, alignItems: 'center' }}>
                    <FieldsButton
                        type="submit"
                        label="Поиск"
                    />
                </div>
            </form>
            <div className={classes.wrap}>
                <TableCasino
                    perPage={50}
                    columns={columns}
                    rows={rows}
                    pagination
                    allPage={data.totalPage}
                     orderByDefault="sum,desc"
                     order={(v) => {
                        setValue(`orderBy`, `${v.id},${v.sort}`);
                        dispatch(setGetReplenishmentGeneralReport({
                            login,
                            currency,
                            count_deposit_max,
                            count_deposit_min,
                            sum_deposit_max,
                            sum_deposit_min,
                            from_date,
                            to_date,
                            page: 1,
                            pageSize: v.rowsPerPage,
                            orderBy: `${v.id},${v.sort}`
                        }))
                    }}
                    changePage={(v) =>
                        dispatch(setGetReplenishmentGeneralReport({
                            login,
                            currency,
                            count_deposit_max,
                            count_deposit_min,
                            sum_deposit_max,
                            sum_deposit_min,
                            from_date,
                            to_date,
                            page: +v.page + 1,
                            pageSize: v.rowsPerPage,
                            orderBy
                        }))
                    }
                    changeRowsPerPage={(v) => dispatch(setGetReplenishmentGeneralReport({
                        login,
                        currency,
                        count_deposit_max,
                        count_deposit_min,
                        sum_deposit_max,
                        sum_deposit_min,
                        from_date,
                        to_date,
                        page: 1,
                        pageSize: v.rowsPerPage,
                        orderBy
                    }))}
                />
            </div>
            {
                isOpenModalAddMailing && (
                    <ModalAddMailing handleChangeModeAddMailing={handleChangeModeAddMailing} login={selectedLogin} />
                )
            }
           
        </div>
    )
}

export default GeneralReport;